import { render, staticRenderFns } from "./appManageInterfaceSub.vue?vue&type=template&id=0260c52a"
import script from "./appManageInterfaceSub.vue?vue&type=script&lang=js"
export * from "./appManageInterfaceSub.vue?vue&type=script&lang=js"
import style0 from "./appManageInterfaceSub.vue?vue&type=style&index=0&id=0260c52a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports